import { trackError } from '@calculatorScripts/telemetry';
import { showProblem } from '@vue/services/toast.service';
import Vue from 'vue';

const handleError = (error) => {
  trackError(error);

  const response = error.response;

  if (response?.headers['content-type']?.includes('problem+json')) {
    showProblem(response);
    return;
  } 
};

window.onunhandledrejection = (event) => handleError(event.reason);

Vue.config.errorHandler = handleError;
